// extracted by mini-css-extract-plugin
module.exports = {"comp":"OverviewNav_comp__aG45S"};